<core-generic-table [dataInput]="voyages()" [endpoint]="endpoint" [listTitle]="'voyages.title' | translate"
  [columns]="columns" [modalFields]="modalFields()" [actions]="actions" [globalActions]="globalActions"
  [customActions]="configCustomActions" [showFilter]="false" [showSelection]="false" [showActions]="true"
  [showCreateButton]="true" [enablePagination]="true" [modelFactory]="voyagesModelFactory" [moreData]="moreData"
  [scrollTable]="true" [onApiError]="onApiError" (onMoreDataLoaded)="onMoreDataLoaded($event)"
  (formReady)="onVoyageFormReady($event)" (modalData)="onVoyageModalData($event)" class="o-layout__section" />

<!-- Custom templates for special columns -->
<ng-template #revenueTemplate let-row let-column="column">
  <span [class.warning]="row.revenue < 0" [class.success]="row.revenue > 0">
    {{row.revenue ? '$' + row.revenue : '$ 0.00'}}
  </span>
</ng-template>
